import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '@/components/main'

Vue.use(VueRouter)
/**
 * 重写路由的push方法
 * 解决重复push路由时，报错 message: "Navigating to current location (XXX) is not allowed"的问题
 *
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

const routes = [
  {
    path: '/',
    component: () => import('@/views/home.vue')
  },
  {
    path: '/about/:pId/:cId',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: main,
    meta: { name: "关于我们" },
    children: [
      {
        path: "",
        name: "about",
        meta: { name: "关于我们" },
        component: () => import('@/views/about/about.vue')
      }
    ]
  },
  {
    path: '/product/:pId/:cId',
    component: main,
    meta: { name: "业务规划" },
    children: [
      {
        path: "",
        name: "product",
        meta: { name: "业务规划" },
        component: () => import('@/views/product/product.vue')
      }
    ]
  },
  {
    path: '/management/:pId/:cId',
    component: main,
    meta: { name: "经营发展" },
    children: [
      {
        path: "",
        name: "management",
        meta: { name: "经营发展" },
        component: () => import('@/views/management/management.vue')
      }
    ]
  },
  {
    path: '/party/:pId/:cId',
    component: main,
    meta: { name: "党的建设" },
    children: [
      {
        path: "",
        name: "party",
        meta: { name: "党的建设" },
        component: () => import('@/views/party/party.vue')
      }
    ]
  },
  {
    path: '/team/:pId/:cId',
    component: main,
    meta: { name: "企业文化" },
    children: [
      {
        path: "",
        name: "team",
        meta: { name: "企业文化" },
        component: () => import('@/views/team/team.vue')
      }
    ]
  },
  {
    path: '/news/:pId/:cId',
    component: main,
    meta: { name: "媒体中心" },
    children: [
      {
        path: "",
        name: "news",
        meta: { name: "媒体中心" },
        component: () => import('@/views/news/news.vue')
      }
    ]
  },
  {
    path: '/links',
    component: main,
    meta: { name: "中国宝武网站群" },
    children: [
      {
        path: "",
        name: "links",
        meta: { name: "中国宝武网站群" },
        component: () => import('@/views/links.vue')
      }
    ]
  },
  {
    path: '/contactus',
    component: main,
    meta: { name: "联系我们" },
    children: [
      {
        path: "",
        name: "contactus",
        meta: { name: "联系我们" },
        component: () => import('@/views/contactus.vue')
      }
    ]
  },
  {
    path: '/search',
    component: main,
    meta: { name: "搜索结果" },
    children: [
      {
        path: "",
        name: "search",
        meta: { name: "搜索结果" },
        component: () => import('@/views/search.vue')
      }
    ]
  }

]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
